import { useState } from 'react'
import AspectRatio from '@mui/joy/AspectRatio'
import Card from '@mui/joy/Card'
import CardOverflow from '@mui/joy/CardOverflow'
import CardContent from '@mui/joy/CardContent'
import CardCover from '@mui/joy/CardCover'
import Button from '@mui/joy/Button'
import Typography from '@mui/joy/Typography'

export const TemplateLibraryItem = ({
    selected,
    template,
    onSelect,
    onClick,
}) => {
    const [hovering, setHovering] = useState(false)

    const handleSelect = (e) => {
        e.stopPropagation()
        onSelect(template)
    }

    return (
        <Card
            sx={{ width: 250, minWidth: 250 }}
            variant={selected ? 'solid' : 'soft'}
            invertedColors={selected}
            color="neutral"
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
            onClick={() => onClick(template)}
        >
            <CardOverflow>
                <AspectRatio ratio="1/1">
                    <img src={template.preview_image} />
                </AspectRatio>
                {hovering && (
                    <>
                        <CardCover sx={{ background: 'rgba(0,0,0,0.4)' }} />
                        <CardCover
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                p: 1,
                            }}
                        >
                            <Button
                                sx={{ maxWidth: 75, maxHeight: 30 }}
                                size="sm"
                                variant="soft"
                                color="neutral"
                                onClick={handleSelect}
                            >
                                {selected ? 'Unselect' : 'Select'}
                            </Button>
                        </CardCover>
                    </>
                )}
            </CardOverflow>
            <CardContent>
                <Typography
                    level="title-md"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {template.title}
                </Typography>
            </CardContent>
        </Card>
    )
}
